import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { LoadingCirculoService } from '../service/loading-circulo.service';
import { Observable } from 'rxjs';
import { LoadingState } from '../model/loading-state.interface';
import { IdsIconComponent } from '@ids/angular';
import { NgIf, NgStyle, AsyncPipe } from '@angular/common';

/**
 * Componente responsável por exibir um indicador de carregamento circular com animações.
 */
@Component({
    selector: 'app-loading-circulo',
    templateUrl: './loading-circulo.component.html',
    styleUrls: ['./loading-circulo.component.scss'],
    standalone: true,
    imports: [NgIf, NgStyle, IdsIconComponent, AsyncPipe]
})
export class LoadingCirculoComponent implements OnInit {

  /** Observable que emite o estado atual do carregamento. */
  public loadingState$: Observable<LoadingState>;

  /** Indica se o indicador de carregamento deve ser exibido. */
  displayLoading: boolean = false;

  /** Indica se a animação de sucesso deve ser exibida. */
  displaySucess: boolean = true;

  /** Classe CSS para animação de texto. */
  classTextAnimation: string = 'text-animation-rigth';

  /** Referência ao elemento do container de carregamento branco. */
  @ViewChild("containerLoadingWhite") containerLoadingWhite: ElementRef;

  /** Referência ao elemento do container de carregamento azul. */
  @ViewChild("containerLoadingBlue") containerLoadingBlue: ElementRef;

  /** Referência ao elemento do container de carregamento de sucesso. */
  @ViewChild("containerLoadingSucess") containerLoadingSucess: ElementRef;

  /** Referência ao elemento do container de descrição de carregamento. */
  @ViewChild("containerLoadingdescription") containerLoadingdescription: ElementRef;

  /** Progresso atual do carregamento, de 0 a 100. */
  progress: number = 0;

  /**
   * Construtor do componente.
   * @param loadingCirculoService Serviço para controle do estado de carregamento.
   * @param renderer Serviço Angular para manipulação de elementos DOM.
   */
  constructor(private loadingCirculoService: LoadingCirculoService, private renderer: Renderer2) { }

  /** Método de ciclo de vida do Angular chamado após a inicialização do componente. */
  ngOnInit(): void {
    this.controlDisplayLoading();
    this.setObservableLoading();
  }

  /** Raio do círculo de carregamento. */
  private readonly radius: number = 59;

  /** Comprimento da circunferência do círculo de carregamento. */
  private readonly circumference: number = 2 * Math.PI * this.radius;

  /**
   * Calcula o deslocamento do traço do círculo de carregamento com base no progresso atual.
   * @returns O valor do deslocamento do traço.
   */
  get strokeDashoffset(): number {
    return this.circumference - (this.progress / 100) * this.circumference;
  }

  /**
   * Retorna o comprimento da circunferência do círculo de carregamento.
   * @returns O comprimento da circunferência.
   */
  get strokeDasharray(): number {
    return this.circumference;
  }

  /**
   * Controla a exibição do indicador de carregamento com base no estado atual.
   */
  private controlDisplayLoading(): void {
    this.loadingCirculoService.loadingStateDisplay$.subscribe((state) => {
      try {
        if (!state && this.containerLoadingWhite) {
          this.renderer.addClass(this.containerLoadingWhite.nativeElement, 'fade-out-animation');
          this.renderer.addClass(this.containerLoadingBlue.nativeElement, 'fade-out-animation');
          if (this.containerLoadingSucess)
            this.renderer.addClass(this.containerLoadingSucess.nativeElement, 'fade-out-animation');
          if (this.containerLoadingdescription)
            this.renderer.addClass(this.containerLoadingdescription.nativeElement, 'fade-out-animation');
          /* o settimeout é para aplicacao de efeitos */
          setTimeout(() => {
            const reset = {
              fillPercentage: 0,
              background: '#001345',
              description: '',
              icon: '',
            }
            this.loadingCirculoService.updateLoadingState(reset);
            this.displayLoading = state;
          }, 500)

        } else {
          this.displayLoading = state;
        }
      } catch (error) {
        this.displayLoading = state;
      }
    });
  }

  /**
   * Configura os observables para monitorar o estado de carregamento.
   */
  private setObservableLoading(): void {
    this.loadingCirculoService.loadingState$.subscribe(() => {
      this.loadingState$ = this.loadingCirculoService.loadingState$;
    });

    this.loadingCirculoService.loadingStateDisplayEfects$.subscribe((value) => {
      if (this.containerLoadingdescription && value) {
        this.classTextAnimation = this.classTextAnimation == 'text-animation-rigth' ? 'text-animation-left' : 'text-animation-rigth';
        this.renderer.addClass(this.containerLoadingdescription.nativeElement, `${this.classTextAnimation}`);
      }
    });
  }

  /**
   * Retorna os estilos de fundo para o estado de carregamento atual.
   * @param state Estado de carregamento atual.
   * @returns Estilos CSS para o fundo.
   */
  getBackgroundStyles(state: LoadingState) {
    this.progress = state.fillPercentage;
    return {
      'height': state.fillPercentage + '%',
      'background-color': state.background,
    };
  }
}